<template>
  <div class="card">
    <div class="card-body">
      <button
        class="btn btn-sm btn-secondary mb-2"
        @click="$emit('regresar')"
        title="Regresar"
      >
        <i class="fa fa-arrow-left ml-4 mr-4"></i>
      </button>
      <div class="row">
        <div class="col-sm-7 mx-auto">
          <div class="alert alert-info btn-color-principal" role="alert">
            Recuerde utilizar archivos con extensión XLS
          </div>
          <form @submit.prevent="guardar" id="form-guia-xls">
            <div class="form-group row mb-2">
              <div class="col-sm-12">
                <label for="inputArchivo" class="col-form-label mb-0 font-weight-bold">Archivo:</label>
                <div class="input-group mb-0">
                  <div class="custom-file">
                    <input type="file" name="archivo" class="custom-file-input custom-file-input-sm" id="inputGroupFile02" @change="setFile" required>
                    <label class="custom-file-label" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">
                      {{ nombre === '' ? 'Buscar...' : nombre }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row mb-2">
              <div class="col-sm-6">
                <label for="inputInicio" class="col-form-label mb-0 font-weight-bold">Inicio:</label>
                <input type="number" class="form-control form-control-sm" name="inicio" required>
              </div>
              <div class="col-sm-6">
                <label for="inputFin" class="col-form-label mb-0 font-weight-bold">Fin:</label>
                <input type="number" class="form-control form-control-sm" name="fin" required>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-12 text-right">
                <a
                  href="/plantilla_guias.xls"
                  class="btn btn-lg btn-success mb-2"
                  target="_blank"
                >Descargar plantilla</a>
                <button class="btn btn-lg btn-primary btn-color-principal ml-3 mb-2" :disabled="btnGuardar">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="btnGuardar"
                  ></span>
                  <span class="sr-only" v-if="btnGuardar">
                    Guardando...
                  </span>
                  <span v-if="!btnGuardar">
                    <i class="fa fa-save"></i> Guardar
                  </span>
                </button>
              </div>
            </div>
          </form>

          <div class="alert alert-info btn-color-principal mt-2" v-if="guias.length > 0">
            ¿Ha terminado de ingresar todas sus guías?<br>

            <div v-for="reco in recolectas" :key="reco.id">
              Por favor confirmar su recolecta # <b>{{ reco.numero }}</b> en el seguiente botón.
              <button type="button" class="btn btn-sm btn-primary btn-color-principal" @click="confirmar(reco)">
                Confirmar recolecta
              </button>
            </div>
          </div>

          <div class="row mt-2" v-if="guias.length > 0">
            <div class="col-sm-12">
              <p>Guías creadas:</p>
              <p class="m-0" v-for="i in guias" :key="i">{{ i }}</p>
              <a :href="UrlBase+'/madre/get_impresion?guias='+ides" target="_blank" class="btn btn-lg btn-success">
                  <i class="fa fa-print"></i> Imprimir
                </a>
            </div>
          </div>

          <div class="alert alert-danger mt-2" role="alert" v-if="errores.length > 0">
            <h4 class="alert-heading">Errores</h4>
            <ul>
              <li v-for="(i, idx) in errores" :key="idx">{{ i }}</li>
            </ul>
          </div>
          <GuiaRecoleccionConfirmar :reco="recolecta"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import Notificacion from '../mixins/Notificacion.js';
  import GuiaRecoleccionConfirmar from './GuiaRecoleccionConfirmar.vue';
  import $ from 'jquery';

  export default {
    name: 'GuiaMadreXls',
    mixins: [Notificacion],
    data: () => {
      return {
        btnGuardar: false,
        nombre: '',
        guias: [],
        ides: [],
        recolectas: [],
        recolecta: null,
        errores: []
      }
    },
    methods: {
      guardar(e) {
        if (confirm('¿Está seguro?')) {
          this.btnGuardar = true;
          this.errores = []

          let datos = new FormData(e.target);

          axios
          .post(`${this.UrlBase}/madre/subir_guia`, datos)
          .then(res => {
            this.btnGuardar = false;

            if (res.data.exito) {
              this.guias = res.data.guias;
              this.ides = res.data.ides;
              this.recolectas = res.data.recolectas;
              this.showSuccessMsg({message: res.data.mensaje});
              e.target.reset();
            } else {
              this.showErrorMsg({message: res.data.mensaje});

              if (res.data.errores) {
                this.errores = res.data.errores
              }
            }

            this.nombre = '';
            let form = document.getElementById('form-guia-xls')
            
            if (form) {
              form.reset()
            }
          }).catch(e => {
            this.btnGuardar = false;
            alert('Xls '+e);
          })
        }
      },
      setFile(e) {
        this.nombre = e.target.files[0].name;
      },
      confirmar (valor) {
        if (confirm('¿Está seguro?')) {
          this.recolecta = valor;
          $("#mdlSalida").modal()
        }
      }
    },
    components: {
      GuiaRecoleccionConfirmar
    }
  };
</script>